import { Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { VoyageFormField } from "./VoyageFormField";

export const VoyageInfo = ({ dataState, setDataState }) => {
    const { t } = useTranslation();

    return (
        <>
            <M_Fieldset
                labelInside
                label={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "25px",
                            marginLeft: "10px",
                        }}
                    >
                        <Article
                            style={{ marginRight: "10px", scale: "1.3" }}
                        />{" "}
                        {t("Information")}
                    </div>
                }
                elements={
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                    >
                        <VoyageFormField
                            label={t("VoyageNumber")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageNumber"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("Vessel")}
                            type={dataState.IsView ? "disabled" : "foreignKey"}
                            entity="Vessel"
                            filterField={"Name"}
                            labelFields={["Name"]}
                            extraFields={[
                                { key: "Id", value: "IdVessel" },
                                { key: "Name", value: "VesselName" },
                            ]}
                            code="VesselName"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("CallStatus")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="CallStatus"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("CallNumber")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageCallNumber"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("CallProcess")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageCallProcess"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("AdditionalCall")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageAdditionalCall"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("AccountingCode")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageAccountingCode"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("Comments")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageComments"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("ElectronicManifestReference")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="EletronicManifestReference"
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                }
            />
        </>
    );
};
